import { AuthContextInterface, withAuthContext } from '@amzn/awscat-react-components';
import { isPC30UserUserId, isPartnerUserId } from '@amzn/caracal-infrastructure-common';
import { FunctionComponent, useEffect, useState } from 'react';

import rumClient from '../../../common/monitoring/RumClient';

type AssessmentCreatedByProps = AuthContextInterface & {
    createdBy: string;
};

const AssessmentCreatedBy: FunctionComponent<AssessmentCreatedByProps> = ({ auth, createdBy }): JSX.Element => {
    const [createdByDetails, setCreatedByDetails] = useState<string | null>(null);

    useEffect(() => {
        async function getCreatedByDetails(userId: string) {
            try {
                // Pass the full userId to getUserInfoList (not just the prefix)
                // Format: "PC30_arn:aws:iam::123456789012:role/exdeny"
                const userProfiles = await auth.getUserInfoList([userId]);
                const userName = userProfiles?.[0]?.name || userProfiles?.[0]?.displayName;
                const userOrg = userProfiles?.[0]?.organizationName || userProfiles?.[0]?.organizationId;
                if (userName && userOrg) {
                    setCreatedByDetails(`${userName} (${userOrg})`);
                    return;
                }
            } catch (error) {
                // unable to get user profile. Not much we can do here
                // fall thru and use userId instead.
                rumClient.recordError(error);
            }

            // Fallback: extract readable part from userId for partner users with IAM ARN format
            // PC30_arn:aws:iam::123456789012:role/exdeny -> 123456789012:role/exdeny
            if (isPC30UserUserId(userId)) {
                const match = userId.match(/:iam::(.+)$/);
                if (match) {
                    setCreatedByDetails(match[1]);
                    return;
                }
            }

            // Display the full original userId as final fallback
            setCreatedByDetails(userId);
        }
        if (createdByDetails === null) {
            if (isPartnerUserId(createdBy)) {
                getCreatedByDetails(createdBy);
            } else {
                setCreatedByDetails(createdBy);
            }
        }
    }, [auth, createdBy, createdByDetails]);

    return <div className='awscat-assessment-created-by'>{createdByDetails}</div>;
};

export default withAuthContext(AssessmentCreatedBy);
